// website/src/authConfig.ts
import {
  PublicClientApplication,
  type Configuration,
} from '@azure/msal-browser';

// Internal (B2B) Config
const internalClientId = import.meta.env.VITE_CLIENT_ID as string;
const internalTenantId = import.meta.env.VITE_TENANT_ID as string;
const internalAuthority = `https://login.microsoftonline.com/${internalTenantId}`;

// External (CIAM) Config
const externalClientId = import.meta.env.VITE_EXTERNAL_CLIENT_ID as string;
const externalAuthority = import.meta.env.VITE_EXTERNAL_AUTHORITY as string;
const externalAppIdentityUri = import.meta.env
  .VITE_EXTERNAL_APP_IDENTITY_URI as string;

const backendApiUrl = import.meta.env.VITE_BACKEND_API_URL as string;
const appIdentityUri = import.meta.env.VITE_APP_IDENTITY_URI as string;

// Determine active auth type
const storedAuthType =
  typeof window !== 'undefined' ? localStorage.getItem('msal_auth_type') : null;
export const isExternalAuth = storedAuthType === 'external';

const internalMsalConfig: Configuration = {
  auth: {
    clientId: internalClientId,
    authority: internalAuthority,
    protocolMode: 'AAD',
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

const externalMsalConfig: Configuration = {
  auth: {
    clientId: externalClientId,
    authority: externalAuthority,
    protocolMode: 'OIDC',
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const msalConfig: Configuration = isExternalAuth
  ? externalMsalConfig
  : internalMsalConfig;

export const internalProtectedResources = {
  assetApi: {
    assetsEndpoint: `${backendApiUrl}/asset`,
    scopes: [`${appIdentityUri}/FMS.Admin`],
  },
};

export const externalProtectedResources = {
  assetApi: {
    assetsEndpoint: `${backendApiUrl}/asset`,
    scopes: [`${externalAppIdentityUri}/FMS.Admin`],
  },
};

export const protectedResources = isExternalAuth
  ? externalProtectedResources
  : internalProtectedResources;

export const internalLoginRequest = {
  scopes: ['User.Read'],
};

export const externalLoginRequest = {
  scopes: ['openid', 'profile', 'offline_access'],
};

export const loginRequest = isExternalAuth
  ? externalLoginRequest
  : internalLoginRequest;

export const internalMsalInstance = new PublicClientApplication(
  internalMsalConfig
);
export const externalMsalInstance = new PublicClientApplication(
  externalMsalConfig
);

export const msalInstance = isExternalAuth
  ? externalMsalInstance
  : internalMsalInstance;
